import React from "react";
const ContactUS = () => {
  return (
    <div className="container" style={{ fontSize: "20px" }}>
      <span className="text-bold" style={{ fontSize: "30px" }}>
        فرم تماس سریع
      </span>
      <br />
      تهران شهریار صباشهر خ مخابرات کوچه شریعت پ 16
      <br />
      <span className="text-bold" style={{ fontSize: "30px" }}>
        تلفن تماس
      </span>
      <br />
      ارتباط با سایه بان : 02165626933
      <br />
      پشتیبانی شیفت: 09198362447
      <br />
      ایمیل : sayyehban@gmail.com
      <br />
      <a href="https://t.me/SayyehBan"> کانال تلگرام</a>
      <br />
      نماد اعتماد
      <br />
      {/* <a
        referrerpolicy="origin"
        target="_blank"
        href="https://trustseal.enamad.ir/?id=214184&amp;Code=oMgLVe0rzb0EPj2tmOHZ"
      >
        <img
          referrerpolicy="origin"
          src="https://Trustseal.eNamad.ir/logo.aspx?id=214184&amp;Code=oMgLVe0rzb0EPj2tmOHZ"
          alt=""
          style={{ cursor: "pointer" }}
          id="oMgLVe0rzb0EPj2tmOHZ"
        />
      </a> */}
      <a
        referrerPolicy="origin"
        target="_blank"
        href="https://trustseal.enamad.ir/?id=214184&amp;Code=oMgLVe0rzb0EPj2tmOHZ"
      >
        <img
          referrerPolicy="origin"
          src="images/LogoEnamad.png"
          alt=""
          style={{ cursor: "pointer" }}
          code="oMgLVe0rzb0EPj2tmOHZ"
        />
      </a>
    </div>
  );
};

export default ContactUS;
